import { ROLE_SUPERADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessStatistics = createHasSessionAccessSelector([ROLE_SUPERADMIN]);